import { render, staticRenderFns } from "./CalculadoraProductoItem.vue?vue&type=template&id=3e0288f3&scoped=true&"
import script from "./CalculadoraProductoItem.vue?vue&type=script&lang=js&"
export * from "./CalculadoraProductoItem.vue?vue&type=script&lang=js&"
import style0 from "./CalculadoraProductoItem.vue?vue&type=style&index=0&id=3e0288f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0288f3",
  null
  
)

export default component.exports